import React from 'react';
import './PC.css';
import Lünborg from '../../img/PC/Thorsten Lünborg.png'
import Nguyen from '../../img/PC/Binh Nguyen.png'
import David from '../../img/PC/Alexandre David.png'
import Dipanjan from '../../img/PC/Dipanjan De.png'
import accenture from '../../img/PC/accenture.png'
import Karkinos from '../../img/PC/Karkinos Healthcare.png'
import VueJS from '../../img/PC/VueJS.png'
import Zope from '../../img/PC/Sanjay Zope.png'
import Meta from '../../img/PC/Meta.png'
import Habinshuti from '../../img/PC/Clément Habinshuti.png'
import Microsoft from '../../img/PC/Microsoft.png'
import Pell from '../../img/PC/David Pell.png'
import Smartcookie from '../../img/PC/Smartcookie Media.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Lünborg,
          name: 'Thorsten Lünborg',
          position: 'Core Member',
          ln: 'https://www.linkedin.com/in/thorstenluenborg/',
          logo: VueJS,
        },
        {
          photo: Nguyen,
          name: 'Binh Nguyen',
          position: 'Creative Technologist',
          github: 'https://thanhbinh710.github.io/',
          logo: accenture,
        },
        {
          photo: Habinshuti,
          name: 'Clément Habinshuti',
          position: 'Software Engineer',
          website: 'https://linktr.ee/habbes',
          logo: Microsoft,
        },
        {
          photo: Zope,
          name: 'Sanjay Zope',
          position: 'Engineering Manager',
          ln: 'https://www.linkedin.com/in/zopesanjay/',
          logo: Meta,
        },
        {
          photo: David,
          name: 'Alexandre David',
          position: 'Lead Front-end developer',
          ln: 'https://www.linkedin.com/in/alexandre-david-798a633a/',
        },
        {
          photo: Dipanjan,
          name: 'Dipanjan De',
          position: 'Product Data Scientist',
          ln: 'https://www.linkedin.com/in/dipanjan131/',
          logo: Karkinos,
        },
        {
          photo: Pell,
          name: 'David Pell',
          position: 'Senior Front-End Developer',
          ln: 'https://www.linkedin.com/in/pelldavid/',
          logo: Smartcookie,
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
          </div>
          <img src={item.logo} className='pc_logo' alt="" />
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc container" id='pc'>
              <h3>Program committee</h3>
              <div className='pc_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}